module.exports = __webpack_public_path__ + "static/media/team_chat.5b21c68a.svg";